import { axios } from "@/lib/axios";
import type { AxiosResponse } from "axios";

// Message detail response type
export interface MessageDetailResponse {
    id: number;
    msgId: string;
    merchantNo: string;
    userId: string;
    title: string;
    summary: string;
    content: string;
    imageUrl: string;
    redirectUrl: string;
    msgType?: string;
    msgTypeId?: string | number;
    readStatus: number;
    tradeNo: string;
    eventNo: string;
    createTime: string;
    updateTime: string;
}

export function apiGetUnreadCount() {
    return axios.get( "/api/front/user/message/unread-count" );
}

// Get trade message page (offsetId/size pagination)
export function apiGetTradeMessagePage( params: {
    offsetId?: number | string;
    size: number;
} ): Promise<AxiosResponse<{ data: MessageDetailResponse[] }>> {
    return axios.get( "/api/front/user/message/trade/page", {
        params: {
            offsetId: params.offsetId,
            size: params.size,
        },
    } );
}

// Get announcement message page (offsetId/size pagination)
export function apiGetAnnouncementMessagePage( params: {
    offsetId?: number | string;
    size: number;
} ): Promise<AxiosResponse<{ data: MessageDetailResponse[] }>> {
    return axios.get( "/api/front/user/message/announcement/page", {
        params: {
            offsetId: params.offsetId,
            size: params.size,
        },
    } );
}

// Mark trade messages as read
export function apiMarkTradeMessageRead() {
    return axios.post( "/api/front/user/message/trade/mark-read" );
}

// Mark announcement messages as read
export function apiMarkAnnouncementMessageRead() {
    return axios.post( "/api/front/user/message/announcement/mark-read" );
}

// Batch delete trade messages
export function apiBatchDeleteTradeMessages( ids: number[] ): Promise<AxiosResponse<any>> {
    return axios.post( "/api/front/user/message/trade/batch-delete", { ids } );
}

// Follow trade notification switch response type
export interface FollowTradeSwitchResponse {
    enable: boolean;
}

// Get trade notification switch status
export function apiGetTradeNotificationSwitch( followUserId: string ): Promise<
    AxiosResponse<{ data: FollowTradeSwitchResponse }>
> {
    return axios.get( "/api/front/user/follow/notification/status", {
        params: {
            followUserId,
        },
    } );
}

// Update trade notification switch status
export function apiUpdateTradeNotificationSwitch( params: {
    enable: boolean;
    followUserId: string;
} ): Promise<AxiosResponse<{ data: FollowTradeSwitchResponse }>> {
    return axios.post( "/api/front/user/follow/notification/trade", {
        enable: params.enable,
        followUserId: params.followUserId,
    } );
}
